export const AD_CATALOG_BOTTOM = `
    <!-- horizontal_bottom -->
    <ins
        class="adsbygoogle"
        style="display:block"
        data-ad-client="ca-pub-4989628462824154"
        data-ad-slot="5726995289"
        data-ad-format="auto"
        data-full-width-responsive="true"
     >
    </ins>
    <script>
         (adsbygoogle = window.adsbygoogle || []).push({});
    </script>
    <!-- horizontal_bottom -->`;
